/**
 * The internal portal has no organisation to borrow a zone from: every absolute time renders in the operator's
 * own browser zone and the shell names it (M5 §6), so a reader in another zone is never misled. Relative times
 * ("12 min ago") are zone-free. The rules/01 §6 helpers still do the formatting; only the zone source differs.
 */

/** Engines report a few zones by their legacy IANA link name; the modern name is what people recognise. */
const LEGACY_ZONE_NAMES: Record<string, string> = {
  "Asia/Calcutta": "Asia/Kolkata",
  "Asia/Saigon": "Asia/Ho_Chi_Minh",
  "Asia/Katmandu": "Asia/Kathmandu",
  "Asia/Rangoon": "Asia/Yangon",
  "Europe/Kiev": "Europe/Kyiv",
};

export function viewerTimezone(): string {
  try {
    const zone = new Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    return LEGACY_ZONE_NAMES[zone] ?? zone;
  } catch {
    return "UTC";
  }
}

export function useViewerTimezone(): string {
  return viewerTimezone();
}
